import React, { useEffect, useState } from "react";
import { FormLabel, FormControl as Input } from "react-bootstrap";
import { RiArrowGoBackLine } from "react-icons/ri";
import DefaultButton from "components/DefaultButton";
import { Get } from "utils/request";
import { useParams } from "react-router";
import ImageInput from "components/Inputs/ImageInput";
import FormCard from "./FormCard";
import "../../../../../assets/css/styles.css";

const Formbody = (props) => {
  const { loading, OnConfirm } = props;

  const [title, SetTitle] = useState("");
  const [image, SetImage] = useState("");
  const [description, SetDescription] = useState("");
  const [link, SetLink] = useState("");

  const { post_id } = useParams();

  const GetData = async () => {
    let response = await Get(`science-plus/references/list?id=${post_id}`);
    if (response?.status === true) {
      SetImage(response?.references?.image);
      SetTitle(response?.references?.title);
      SetDescription(response?.references?.description);
      SetLink(response?.references?.link);
    }
  };

  useEffect(GetData, []);

  return (
    <div className="form-course">
      <form>
        <FormLabel>
          Imagem da postagem <span style={{ color: "red" }}>*</span>
        </FormLabel>
        <ImageInput ImageChange={(image) => SetImage(image)} path={image} />
        <br />

        <FormLabel>
          Título <span style={{ color: "red" }}>*</span>
        </FormLabel>
        <Input
          placeholder="Título"
          value={title}
          onChange={(e) => SetTitle(e.target.value)}
          required
        />
        <br />

        <FormLabel>
          Link <span style={{ color: "red" }}>*</span>
        </FormLabel>
        <Input
          placeholder="Link"
          value={link}
          onChange={(e) => SetLink(e.target.value)}
          required
        />
        <br />

        <FormLabel>Descrição</FormLabel>
        <Input
          placeholder="Descrição"
          value={description}
          onChange={(e) => SetDescription(e.target.value)}
          required
          as="textarea"
        />
        <br />
      </form>
      <br />
      <div className="w100 inline-flex jcsb mt-2">
        <DefaultButton
          bg="secondary"
          text="Voltar"
          icon={<RiArrowGoBackLine />}
          to="/science-plus/list"
        />
        <DefaultButton
          bg="confirm"
          text="Salvar postagem"
          onClick={() => {
            let data = {
              title: title,
              image: image,
              description: description,
            };
            OnConfirm(data);
          }}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Formbody;
